/** Antal artiklar per sida i /blogg (?sida=N). */
export const BLOG_PAGE_SIZE = 24;

/** Tolkar ?sida= – allt som inte är ett heltal ≥ 1 blir sida 1. */
export function parsePageParam(value: unknown): number {
  const n = typeof value === "number" ? value : typeof value === "string" ? Number(value) : NaN;
  return Number.isInteger(n) && n >= 1 ? n : 1;
}

export function pageCount(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}

/** Elementen på en given sida (1-indexerad). */
export function pageSlice<T>(items: T[], page: number, pageSize: number): T[] {
  return items.slice((page - 1) * pageSize, page * pageSize);
}

/** Href för en listsida: sida 1 är basadressen utan parameter. */
export function pageHref(basePath: string, page: number): string {
  return page <= 1 ? basePath : `${basePath}?sida=${page}`;
}
